/* STILAUTO — Theme JavaScript */

document.addEventListener('DOMContentLoaded', function() {

  /* --- Mobile Menu Toggle --- */
  const menuToggle = document.querySelector('.menu-toggle');
  const mainNav = document.querySelector('.main-nav');
  if (menuToggle && mainNav) {
    menuToggle.addEventListener('click', function() {
      mainNav.classList.toggle('mobile-open');
      this.setAttribute('aria-expanded',
        mainNav.classList.contains('mobile-open'));
    });
  }

  /* --- Finder Tabs --- */
  document.querySelectorAll('.finder-tab').forEach(function(tab) {
    tab.addEventListener('click', function() {
      const parent = this.closest('.finder-card');
      parent.querySelectorAll('.finder-tab').forEach(t => t.classList.remove('active'));
      parent.querySelectorAll('.finder-panel').forEach(p => p.style.display = 'none');
      this.classList.add('active');
      const target = parent.querySelector('#' + this.dataset.target);
      if (target) target.style.display = 'block';
    });
  });

  /* --- Quantity Controls --- handled in main-product.liquid */

  /* --- Scroll Reveal Animation --- */
  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.reveal-on-scroll').forEach(function(el) {
    observer.observe(el);
  });

  /* --- Sticky header shadow --- */
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 20) {
        header.style.boxShadow = '0 4px 20px rgba(0,0,0,0.3)';
      } else {
        header.style.boxShadow = 'none';
      }
    });
  }

  /* --- Product gallery --- handled in main-product.liquid */

});
